module.exports = __webpack_public_path__ + "static/media/EIGHT.4f5ecc49.png";